import { StyledAnnouncementBar } from './styles/AnnouncementBar';

export default StyledAnnouncementBar;
